import React, { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { LeftSidebarFinalSubnav } from "components/LeftSidebar/LeftSidebarFinalSubnav";
import {
  useAvailableSteps,
  useSubType,
  useWizardActions,
  useWizardStep,
  useTopology,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { useWizardData } from "hooks/wizardHooks";
import { isFinalWizardStepDisabled } from "../wizardHelpers";

import s from "./wizardLeftSidebar.module.scss";

export const WizardLeftSidebar = Scrivito.connect(() => {
  const step = useWizardStep();
  const availableSteps = useAvailableSteps();
  const { getWizardData } = useWizardActions();
  const subType = useSubType();
  const { wizardSubTypeObj, wizardItemStepsTitles } = useWizardData(subType);
  const isIntro = useMemo(() => step === 0, [step]);
  const topology = useTopology();
  const topologyStatus = topology?.[0]?.status;

  const isStepDisabled = useCallback(
    (idx) =>
      isFinalWizardStepDisabled(idx, topologyStatus, subType, availableSteps),
    [topologyStatus, subType, availableSteps],
  );

  const handleNavigateToStep = useCallback(
    (e) => {
      if (isStepDisabled(Number(e.target.id))) return;
      getWizardData(Number(e.target.id));
    },
    [isStepDisabled, getWizardData],
  );

  return (
    <LeftSidebarFinalSubnav activeItem={wizardSubTypeObj}>
      {wizardItemStepsTitles?.map((item, idx) => (
        <li
          className={cx("position-relative p-4 text-nowrap", {
            "text-white cursor-pointer": !isStepDisabled(idx),
            [s.hoveredLeftSidebarItem]: !isStepDisabled(idx),
            [s.hoveredLeftSidebarItemActive]:
              (!isIntro && idx === step) || (isIntro && idx === 0),
            "cursor-not-allowed pointer-events-none text-gray-500":
              isStepDisabled(idx),
          })}
          key={item}
          id={idx.toString()}
          onClick={handleNavigateToStep}
        >
          {item}
        </li>
      ))}
    </LeftSidebarFinalSubnav>
  );
});
